/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ArrowLeft/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ArrowLeft({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ArrowLeft",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 11,
  height = 10,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ArrowLeft.Svg"
  data-view-path={viewPath}
 viewBox="0 0 11 10"
 style={{'--as-1-1kwT8S': alignSelf,'--mt-2-1kwT8S': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1kwT8S': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1kwT8S': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1kwT8S': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1kwT8S': opacity,'--w-10-1kwT8S': typeof width === 'number' ? `${width}px` : width,'--h-11-1kwT8S': typeof height === 'number' ? `${height}px` : height,'--f-12-1kwT8S': fill,'--a-7-1kwT8S': isAnimated ? animation : "none",'--sd-8-1kwT8S': isAnimated ? strokeDashoffset : 0,'--sd-9-1kwT8S': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2ArrowLeft.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_2176_3990)"
 className="views-block"
>
<path
  data-testid="Tysiav2ArrowLeft.SvgPath"
  data-view-path={viewPath}
 d="M6.214.357a.357.357 0 00-.61-.252l-4.382 4.39a.7.7 0 000 1.01l4.382 4.39a.357.357 0 00.61-.252V.357z"
 style={{'--f-12-1kwT8S': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}